export default "__VITE_ASSET__BREtuoUR__"